import React from 'react';
import './GalleryDoc.css';
import { SideMenuBar } from '../../SideMenu';
import { NewHeader } from '../../NewHeader';

const GalleryDoc = () => {
return( 
<div>
    <SideMenuBar></SideMenuBar>
    <div class="content">
        <NewHeader></NewHeader>
            
        <div className='row2'>
            <h3 className='gallery_GalleryDoc'>Gallery</h3>  
        </div>

        <div className='row3_GalleryDoc'>
            <div className='heading_GalleryDoc'>
                <a href='/GalleryMedia' className='a_of_heading_GalleryDoc'><p className='media_GalleryDoc'>&nbsp;Media&nbsp;</p></a>
                <a href='/GalleryDoc' className='a_of_heading_GalleryDoc'><p className='documents_GalleryDoc'>&nbsp;Documents&nbsp;</p></a>
            </div>
            <div className='subrow1_row3_GalleryDoc'>
                <a href='/'><img className='uploadPhoto_icon_GalleryDoc' src='../assets/gallery.png' alt='upload-icon'></img></a>
            </div>
    
            
        </div>

        
        

    </div>
</div>
 )
}

export default GalleryDoc;